import React from 'react';
import { Typography } from '@mui/material';
import { GuideSection } from '../common/GuideSection';
import { StepByStep } from '../common/StepByStep';
import { Tip } from '../common/Tip';
import { useTranslation } from '../../../i18n';

export const UploadFlightDataSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GuideSection id="upload-flight-data" title={t('guide.sections.uploadFlightData')}>
      <Typography variant="body1" sx={{ mb: 2, color: '#555' }}>
        {t('guide.uploadFlightData.intro')}
      </Typography>

      <StepByStep
        steps={[
          t('guide.uploadFlightData.steps.s1'),
          t('guide.uploadFlightData.steps.s2'),
          t('guide.uploadFlightData.steps.s3'),
          t('guide.uploadFlightData.steps.s4'),
          t('guide.uploadFlightData.steps.s5'),
          t('guide.uploadFlightData.steps.s6'),
          t('guide.uploadFlightData.steps.s7'),
        ]}
      />

      <Tip>{t('guide.uploadFlightData.tipDocuments')}</Tip>
      <Tip>{t('guide.uploadFlightData.tipAnalyze')}</Tip>
      <Tip>{t('guide.uploadFlightData.tipPlotting')}</Tip>
    </GuideSection>
  );
};
